import type { ValidatedEnv } from '../stores/environment'
import { useEnvironmentStore } from '../stores/environment'

// Safe access to process.env that works in both browser and Node
function getProcessEnv(): ValidatedEnv {
  return typeof process !== 'undefined' && process.env
    ? // oxlint-disable-next-line typescript/consistent-type-assertions
      (process.env as unknown as ValidatedEnv)
    : // oxlint-disable-next-line typescript/consistent-type-assertions
      ({} as ValidatedEnv)
}

// Initialize the environment
export async function initEnv() {
  return useEnvironmentStore.getState().initialize()
}

export function isNodeEnvironment(): boolean {
  return typeof globalThis !== 'undefined' && globalThis.global !== undefined && globalThis.window === undefined
}

export function isTestEnvironment(): boolean {
  const env = getProcessEnv()
  return env.VITE_MODE === 'test' || ('VITEST' in env && env.VITEST === 'true')
}

// Compatible getEnv function for existing code
export function getEnv(): ValidatedEnv {
  const store = useEnvironmentStore.getState()

  if (!store.isInitialized || !store.validatedEnv) {
    if (isNodeEnvironment() || isTestEnvironment()) {
      return getProcessEnv()
    }
    throw new Error('Environment is not initialized')
  }

  // Return the validated environment
  return store.validatedEnv
}

// Export derived environment values for convenience
export function isProduction() {
  return useEnvironmentStore.getState().isProduction
}

export function isStaging() {
  return useEnvironmentStore.getState().isStaging
}

export function isLive() {
  return useEnvironmentStore.getState().isLive
}

export function isDev() {
  return useEnvironmentStore.getState().isDev
}

export function getLaterSocialUrl() {
  return useEnvironmentStore.getState().LATER_SOCIAL_URL
}

export function getMavelyCreatorBaseUrl() {
  return useEnvironmentStore.getState().MAVELY_CREATOR_BASE_URL
}
